<template>
    <div class="stepBox">
        <el-steps :active="this.$store.state.stepNum" align-center :space="spaceRange" class="elSteps">
            <el-step title="上传照片"></el-step>
            <el-step title="编辑"></el-step>
            <el-step title="下载"></el-step>
        </el-steps>
    </div>
</template>

<script>
    export default {
        name:"step",
        data(){
            return{
                spaceRange:"30%"
            }
        },
    }
</script>

<style scoped>
    .stepBox{
        width: 1000px;
        height: 80px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
    }
    .stepBox .elSteps{
        width: 100%;
    }
    .stepBox .elSteps .is-finish{
        color: #d82a22;
        border-color: #d82a22;
    }
</style>
